// アプリケーションで共通で使う関数と発火イベントを記載する

// ==============================
// グローバル名前空間（window.Janreco）
// ==============================
// en対応 Step1: locale付きURL（/zh-TW/... /en/...）の判定を各JSへ複製しないための共通関数。
// 対応locale一覧は layout の <html data-locale-prefixes> から受け取る（JSに列挙しない）。
window.Janreco = window.Janreco || {};

(function (Janreco) {
  // <html data-locale-prefixes> のJSON配列を読む。未設定・壊れている場合は空配列にする
  function localePrefixes() {
    var root = document.documentElement;
    var raw = root ? root.getAttribute('data-locale-prefixes') : null;
    if (!raw) {
      return [];
    }
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  // pathname 先頭の locale プレフィックスだけを取り除く。
  // セグメント境界で判定するため `/enough` は `en` プレフィックスと誤認しない。
  Janreco.stripLocalePrefix = function (pathname) {
    var path = typeof pathname === 'string' ? pathname : window.location.pathname;
    var prefixes = localePrefixes();

    for (var i = 0; i < prefixes.length; i++) {
      var prefix = '/' + prefixes[i];
      if (path === prefix) {
        return '/';
      }
      if (path.indexOf(prefix + '/') === 0) {
        return path.slice(prefix.length);
      }
    }
    return path;
  };

  // 現在ページの locale プレフィックスを除いた pathname
  Janreco.currentPath = function () {
    return Janreco.stripLocalePrefix(window.location.pathname);
  };

  // en対応 Step2: JS側の複数形解決。
  // サーバ側は Rails I18n が複数形を解決するが、JSが組み立てる文言（「%{count}名追加」等）は
  // HAML から data属性で `{ one: '...', other: '...' }` を受け取り、ここで枝を選ぶ。
  // 枝の選び方は Rails I18n の :en ルールに合わせる（count === 1 のみ one、0 と 2以上は other）。
  // ja / zh-TW は複数形を持たないため one を省いた `{ other: '...' }` 単独でもよい。
  // 文字列を直接渡された場合は枝選択せずプレースホルダ置換だけを行う。
  Janreco.pluralize = function (forms, count) {
    var template;

    if (typeof forms === 'string') {
      template = forms;
    } else if (forms && typeof forms === 'object') {
      template = (count === 1 && typeof forms.one === 'string') ? forms.one : forms.other;
      if (typeof template !== 'string') {
        template = typeof forms.one === 'string' ? forms.one : '';
      }
    } else {
      return '';
    }

    return template.replace(/%\{count\}/g, String(count));
  };

  // フォームの入力警告（shared/form/_warning）の行を表示・削除する。
  // key は警告の種類（例: 'seat-duplicate'）。文言は ul の data-msg-<key> から読み、li の ID は「ul の ID_key」。
  // level: 'error'（保存できない: 赤い×）/ 'caution'（保存できる注意: 黄色の！）。見た目は components/_form.scss
  Janreco.toggleFormWarning = function (listSelector, key, isShown, level) {
    var $list = $(listSelector);
    if (!$list.length) return;

    var itemId = $list.attr('id') + '_' + key;
    var $item = $('#' + itemId);
    if (!isShown) {
      $item.remove();
      return;
    }
    if ($item.length) return;

    var isError = level === 'error';
    var $icon = $('<i>', {
      class: 'form-warning__icon fa-solid ' + (isError ? 'fa-xmark' : 'fa-triangle-exclamation'),
      'aria-hidden': 'true',
    });
    var $text = $('<span>').text($list.data('msg-' + key) || '');
    $('<li>', { id: itemId, class: 'form-warning__item form-warning__item--' + (isError ? 'error' : 'caution') })
      .append($icon, $text)
      .appendTo($list);
  };
})(window.Janreco);


  // ==============================
  // 関数
  // ==============================
  // ⚫︎ 特定のテーブルの項目でソート(昇順・降順)する関数
  function sortTable(columnIndex, tableId) {
      var table, rows, switching, i, x, y, shouldSwitch, dir, switchCount = 0;
      // テーブル要素を取得
      table = document.querySelector(tableId);
      switching = true;
      // 初期のソート方向を昇順に設定
      dir = "asc";
      
      // ソートが完了するまでループ
      while (switching) {
        switching = false;
        // テーブルの行を取得
        rows = table.rows;
        
        // テーブルの各行をループ
        for (i = 1; i < (rows.length - 1); i++) {
          shouldSwitch = false;
          // 比較する2つのセルを取得
          x = rows[i].getElementsByTagName("TD")[columnIndex];
          y = rows[i + 1].getElementsByTagName("TD")[columnIndex];
          
          // 昇順の場合の比較
          if (dir == "asc") {
            if (parseInt(x.innerHTML) > parseInt(y.innerHTML)) {
              shouldSwitch = true;
              break;
            }
          // 降順の場合の比較
          } else if (dir == "desc") {
            if (parseInt(x.innerHTML) < parseInt(y.innerHTML)) {
              shouldSwitch = true;
              break;
            }
          }
        }
        
        // 行を入れ替える必要がある場合
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchCount++;
        } else {
          // ソートが完了していない場合、方向を変更して再度ソート
          if (switchCount == 0 && dir == "asc") {
            dir = "desc";
            switching = true;
          }
        }
      }

      // アイコンの色を変更
      var thElements = table.querySelectorAll('th');
      thElements.forEach(function(th, index) {
        var upIcon = th.querySelector('.fa-sort-up');
        var downIcon = th.querySelector('.fa-sort-down');
        if (upIcon && downIcon) { // アイコンが存在するかチェック
          if (index === columnIndex) {
            if (dir === "asc") {
              upIcon.style.color = "#757575";
              downIcon.style.color = "#cfcfcf";
            } else {
              upIcon.style.color = "#cfcfcf";
              downIcon.style.color = "#757575";
            }
          } else {
            upIcon.style.color = "#cfcfcf";
            downIcon.style.color = "#cfcfcf";
          }
        }
      });
    }
  // ==============================
  // イベント発火
  // ==============================
  $(document).on('turbolinks:load', function () {
    // テーブルの項目でソート(昇順・降順)する
    $('#result-by-players-list table th').on('click', function() {
      // クリックされた列のインデックスを取得
      var columnIndex = this.cellIndex;
      // テーブルIDを設定
      var tableId = "#result-by-players-list table";
      // ソート関数を呼び出し
      sortTable(columnIndex, tableId);
  });
});

// ページ上部へ戻るボタン
$(document).on('click', '.js-scroll-top', function() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});